<template>
  <div class="torricelli-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula-chip" v-latex>$v = √(2gh) | 理想孔流速度$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- The Tank -->
          <rect x="100" y="40" width="80" height="160" fill="rgba(34, 166, 179, 0.1)" stroke="#888" />
          
          <!-- Water Level -->
          <rect x="101" :y="200 - level" width="78" :height="level" fill="#22a6b3" opacity="0.4" />

          <!-- Holes and Jets -->
          <g v-for="h in holes" :key="h.y">
             <circle :cx="180" :cy="h.y" r="3" fill="#222" stroke="#888" />
             <!-- Jet Path (Parabolic) -->
             <path v-if="level > (200 - h.y)" :d="getJetPath(h.y)" fill="none" stroke="#22a6b3" stroke-width="2" opacity="0.6" />
          </g>

          <text x="110" y="30" fill="#888" font-size="8">水箱深度 (H)</text>
          <line x1="100" y1="200" x2="350" y2="200" stroke="#888" stroke-width="1" /> <!-- Floor -->
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>最高孔流速: {{ (Math.sqrt(2 * 9.8 * level/10)).toFixed(1) }} m/s</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row items-center">
             <label>调节水箱水位</label>
             <el-slider v-model="level" :min="10" :max="150" size="mini"></el-slider>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>托里拆利定律揭示了液体从小孔流出的速度与其液面高度的关系。根据**能量守恒**，液面处的势能转化为小孔处的动能，其流速公式与物体从相同高度自由落体的末速度完全一致：$v = \sqrt{2gh}$。有趣的是，中部的孔通常喷射最远，因为这是流线轨迹和压强分布的最优平衡点。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TorricelliLawViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      level: 100,
      holes: [{y: 80}, {y: 130}, {y: 180}]
    }
  },
  methods: {
    getJetPath(holeY) {
       const h = this.level - (200 - holeY);
       if (h <= 0) return "";
       
       // v = sqrt(2gh)
       // Range x = v * t, where t = sqrt(2 * (200-holeY) / g)
       // Simplified projection:
       const vx = Math.sqrt(h) * 5;
       const points = [];
       for (let t = 0; t < 20; t++) {
          const x = 180 + vx * t;
          const y = holeY + 0.5 * 1 * t * t;
          points.push(`${x.toFixed(1)},${y.toFixed(1)}`);
          if (y >= 200) break;
       }
       return points.length > 0 ? "M " + points.join(" L ") : "";
    }
  }
}
</script>

<style scoped lang="scss">
.torricelli-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.viz-header { display: flex; justify-content: space-between; align-items: center; padding: 0 4px; .brief { font-size: 13.5px; color: #1e293b; font-weight: 500; } .formula-chip { color: #0891b2; background: rgba(8, 145, 178, 0.1); padding: 4px 12px; border-radius: 8px; font-weight: bold; } }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(34, 166, 179, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
